import { Route } from '@angular/router';
import LoginComponent from './authentication/components/login/login.component';
import { RegisterComponent } from './authentication/components/register/register.component';
import { AuthGuard } from './authentication/guards/auth.guard';
import { LayoutComponent } from './layout/layout/layout.component';

export const appRoutes: Route[] = [
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  {
    path: 'portal',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        title: 'Dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.routes'),
      },
      {
        path: 'profile',
        title: 'Mi perfil',
        loadChildren: () => import('./pages/profile/profile.routes'),
      },
      {
        path: 'cfdis',
        title: 'CFDI Emitidos',
        loadChildren: () => import('./pages/cfdi-reports/cfdi.routes'),
      },
      {
        path: 'emisores',
        title: 'Emisores CFDI',
        loadChildren: () => import('./pages/companies/companies.routes'),
      },
      {
        path: 'components',
        title: 'Componentes Material',
        loadChildren: () => import('./pages/test-components/test-components.routes'),
      },
      {
        path: 'carta-porte-imile',
        title: 'Importación Carta Porte (TXT)',
        loadChildren: () => import('./pages/carta-porte-imile/carta-porte-imile.routes'),
      }
    ],
  },
  { path: '', redirectTo: 'portal', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' },
];
